import { Dimensions, Platform } from 'react-native';
import { asScaled } from '../utils';
const { width } = Dimensions.get('window');
const isIOS = Platform.OS === 'ios';
// 左右边距
const PADDING_HORIZONTAL = 10;
// 日期间的间隔
const DAY_ITEM_SPACE = 3;
const calendarLayout = {
    wrapper: {
        // 左右边距
        paddingHorizontal: PADDING_HORIZONTAL
    },
    dayItem: {
        // 日期间的间隔
        space: DAY_ITEM_SPACE,
        // 日期按钮高度
        height: 54,
        // 日历左右各有10的间距
        width: (width - PADDING_HORIZONTAL * 2 - DAY_ITEM_SPACE * 6) / 7,
        // 日期按钮间距
        padding: 4,
        // 日期按钮圆角
        radius: 12,
        // 箭头距离边上的距离
        arrowDistance: isIOS ? 1 : 0
    },
    // 日期中的图片
    dayImage: {
        width: 16,
        height: 16
    },
    dayRow: {
        // 每一列日期间的距离
        bottom: 3
    },
    weekHeader: {
        height: 40
    },
    monthHeader: {
        // 月份日历头部高度
        height: 40,
        // 月份日历头部marginBottom
        marginBottom: 3,
        // 月份日历头部marginTop
        marginTop: 5,
        // 月份头部两边距离
        paddingHorizontal: 24
    },
    // 主标题和副标题间的分割线
    monthHeaderLine: {
        marginLeft: 4,
        marginRight: 7,
        height: 12,
        width: 0.5
    },
    // 月份头部运营区域图片
    monthHeaderOprImage: {
        height: 18,
        width: 18,
        marginRight: 8
    },
    // 月份头部运营区域箭头
    monthHeaderOprArrow: {
        paddingTop: 1,
        marginLeft: 5
    },
    // 月份头部运营区域背景图
    monthHeaderOprBgImage: {
        height: 40,
        minWidth: 180
    },
    // 底部展示的月份数字
    monthUnderText: {
        size: 200
    },
    toolTip: {
        paddingHorizontal: 16,
        paddingVertical: 8,
        // 圆角
        borderRadius: 8,
        // tooltip箭头宽度
        arrowWidth: 6,
        // tooltip箭头高度
        arrowHeight: 5
    }
};
const calendarLayoutScaled = asScaled(calendarLayout);
export const calendar = {
    scaled: calendarLayoutScaled,
    unscaled: calendarLayout
};
